import { HTMLAttributes } from "react";

export default function LemonSqueezy(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.548 29.3093L31.0668 35.0972C32.6185 35.8148 33.7137 37.0193 34.3052 38.401C35.8012 41.8998 33.7565 45.4782 30.5468 46.7652C27.3365 48.0515 23.9152 47.2237 22.3595 43.5852L16.9113 30.811C16.4891 29.8208 17.5497 28.8478 18.548 29.3093Z"
        fill="#FFC233"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2984 25.5627L32.2212 20.6777C36.516 19.0542 41.2075 22.126 41.1442 26.5893C41.1432 26.6477 41.1422 26.7058 41.1407 26.7647C41.0478 31.111 36.4868 34.0323 32.2863 32.4947L19.3107 27.7455C18.2756 27.3668 18.2679 25.9522 19.2984 25.5627Z"
        fill="#FFC233"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.575 23.8707L31.2785 18.4728C35.4998 16.6789 36.5712 11.2949 33.265 8.18405C33.2217 8.14309 33.1783 8.1026 33.1345 8.06214C29.893 5.05345 24.5347 6.11279 22.6893 10.0757L16.9887 22.3192C16.5339 23.2955 17.5618 24.301 18.575 23.8707Z"
        fill="#FFC233"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3058 21.7377L19.9244 9.07358C20.497 7.50333 20.391 5.902 19.799 4.52033C18.2999 1.02297 14.2402 -0.105966 11.0309 1.1829C7.82214 2.47227 6.00897 5.40048 7.5677 9.03755L13.0516 21.7978C13.4768 22.7867 14.9377 22.7477 15.3058 21.7377Z"
        fill="#FFC233"
      />
    </svg>
  )
}
